import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { topics } from "@/mocks/topics";

const stats = [
  { value: "128", label: "已归档事件" },
  { value: "640+", label: "对比说法条目" },
  { value: "2.3 天", label: "平均回应等待" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const featured = topics[1];

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/list?q=${encodeURIComponent(q)}` : "/list");
  };

  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-12">
        <div className="animate-fade-up lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-50 px-3 py-1 font-label text-xs font-medium text-accent-900">
            <i className="ri-map-pin-2-line"></i>
            多方说法观测台
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            网红大瓜多方说法，
            <br />
            <span className="text-primary-600">放在一起才看得清</span>
          </h1>

          <p className="mt-5 max-w-xl font-label text-sm leading-relaxed text-foreground-600 md:text-base">
            集中汇总网红大瓜多方爆料、当事人回应与对质现场，把说过的、回避的、后续新说的摊在同一版面上对比。从多段回应里，一眼看出谁在含糊、谁在转移话题。
          </p>

          <form onSubmit={handleSearch} className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <div className="relative flex-1">
              <span className="pointer-events-none absolute left-4 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜博主昵称、事件关键词，如「退款」「对质」"
                aria-label="搜索大瓜事件"
                className="w-full rounded-md border border-background-300 bg-background-50 py-3 pl-11 pr-4 font-label text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
              />
            </div>
            <button
              type="submit"
              className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-300"
            >
              <i className="ri-search-eye-line"></i>
              查说法对比
            </button>
          </form>

          <dl className="mt-9 grid max-w-lg grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {stats.map((s) => (
              <div key={s.label}>
                <dt className="font-heading text-2xl font-bold text-foreground-950">{s.value}</dt>
                <dd className="mt-1 font-label text-xs text-foreground-500">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-fade-up lg:col-span-5">
          <div className="relative">
            <div className="h-64 w-full overflow-hidden rounded-lg border border-background-200 md:h-80 lg:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20overlapping%20speech%20bubbles%20and%20newspaper%20fragments%20in%20coral%20red%2C%20amber%20gold%20and%20warm%20cream%20beige%2C%20minimalist%20magazine%20cover%20style%2C%20soft%20geometric%20shapes%2C%20clean%20composition%20on%20warm%20neutral%20background%2C%20high%20detail&width=1200&height=1400&seq=gossip-hero-main&orientation=portrait"
                alt="多方说法对比示意图"
                title="网红大瓜 多方说法对比 - 吃瓜观测站"
                className="h-full w-full object-top"
              />
            </div>

            <Link
              to={`/topic/${featured.id}`}
              className="absolute -bottom-5 left-4 right-4 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300 md:left-6 md:right-6"
            >
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-mic-line text-lg"></i>
              </span>
              <span className="min-w-0">
                <span className="block font-label text-[11px] tracking-wide text-primary-600">
                  正在进行 · 双方连线对质
                </span>
                <span className="mt-0.5 block truncate font-heading text-sm font-semibold text-foreground-950">
                  {featured.title}
                </span>
              </span>
              <i className="ri-arrow-right-line ml-auto flex-none text-foreground-400"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}